import React from "react";

const ORDINAL_LABELS = ["Normal", "Mild", "Moderate", "Severe"];

const describeOrdinal = value => Number.isInteger(value) && ORDINAL_LABELS[value]
  ? `${ORDINAL_LABELS[value]} (${value})`
  : "Not available";

export default function CategoricalReferenceFeedback({
  constructLabel,
  sourceParameterLabel,
  sourceLabel,
  learnerValue,
  reference,
  sourceHelp,
}) {
  if (!reference) return null;
  const distribution = reference.distribution || {};

  return (
    <section className="av-categorical-feedback" aria-label={`${constructLabel} reference feedback`}>
      <h3>Reference feedback</h3>
      <h4>{constructLabel}</h4>
      <div className="av-categorical-feedback__summary">
        <div className="av-categorical-feedback__summary-item"><span>Your rating</span><strong>{describeOrdinal(learnerValue)}</strong></div>
        <div className="av-categorical-feedback__summary-item">
          <span className="av-methodology-heading">
            <span>{sourceLabel} — {sourceParameterLabel}</span>
            {sourceHelp}
          </span>
          <strong>Reference median: {describeOrdinal(reference.referenceOrdinal)}</strong>
        </div>
      </div>
      <p className="av-categorical-feedback__interpretation">
        The median summarizes the expert ratings; the distribution shows how those judgments varied.
      </p>
      <ul className="av-categorical-feedback__distribution" aria-label={`${sourceParameterLabel} expert rating distribution`}>
        {ORDINAL_LABELS.map((label, ordinal) => (
          <li key={label}>
            <span>{label}</span>
            <span className="av-categorical-feedback__bar" aria-hidden="true">
              <span style={{ width: `${reference.sampleSize ? (Number(distribution[ordinal] || 0) / reference.sampleSize) * 100 : 0}%` }} />
            </span>
            <strong>{Number(distribution[ordinal] || 0)}</strong>
          </li>
        ))}
      </ul>
      <p>{reference.sampleSize} expert ratings</p>
    </section>
  );
}

export { ORDINAL_LABELS, describeOrdinal };
